import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const scrollTriggerConfig = {
    start: "top+=50 center",
    end: "bottom+=100 center+=100",
    toggleActions: "play reverse play reverse",
};

// const scrollTriggerConfigScale = {
//     start: "top-=50 80%",
//     end: "bottom 10%",
//     toggleActions: "play reverse play reverse",
// };

const DURATION = 0.3;

export function ComponentContainer({ image, video, bgColor, children, classNames = "", isAnimated = true }) {
    const containerRef = useRef(null);
    const mmRef = useRef(gsap.matchMedia());

    useGSAP(() => {
        const containers = gsap.utils.toArray(".component-container.--react");
        if (!containers.length) return;

        if (isAnimated) {
            mmRef.current.add("(min-width: 640px)", () => {
                containers.forEach((container) => {
                    // Padding animation
                    gsap.to(container, {
                        padding: 0,
                        duration: DURATION,
                        scrollTrigger: {
                            trigger: container,
                            ...scrollTriggerConfig,
                        },
                    });

                    let bgEl = container.querySelector(".component-container-bg-el");
                    let componentWrapperEl = container.querySelector(".component-container-content");

                    if (bgEl) {
                        gsap.to(bgEl, {
                            duration: DURATION,
                            borderRadius: 0,
                            scrollTrigger: {
                                trigger: container,
                                ...scrollTriggerConfig,
                            },
                        });
                    }

                    if (componentWrapperEl) {
                        gsap.to(componentWrapperEl, {
                            duration: DURATION,
                            borderRadius: 0,
                            scrollTrigger: {
                                trigger: container,
                                ...scrollTriggerConfig,
                            },
                        });
                    }
                });
            });
        }
    });

    return (
        <div ref={containerRef} className={`component-container --react ${classNames}`} data-animated={isAnimated}>
            <div className="component-wrapper">
                {image && <img className="component-container-bg-el" src={image} alt="Max Capital"></img>}

                {video && (
                    <video autoplay loop muted className="component-container-bg-el">
                        <source src={video} type="video/mp4" />
                        Your browser does not support HTML5 video.
                    </video>
                )}

                <div className="component-container-content" style={{ background: bgColor || "transparent" }}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export function LayoutGrid({
    spacingTop,
    spacingBottom,
    componentId,
    children,
    cols,
    classNames = "",
    rowGap = "0",
    isFullWidth = false,
}) {
    return isFullWidth ? (
        <div
            className={`component-layout pt-${spacingTop} pb-${spacingBottom} ${classNames || ""} full-width`}
            id={componentId || ""}
        >
            {children}
        </div>
    ) : (
        <div
            className={`component-layout pt-${spacingTop} pb-${spacingBottom} ${classNames || ""}`}
            id={componentId || ""}
        >
            <div style={{ rowGap: rowGap }} className={`component-layout-wrapper cols-${cols}`}>
                {children}
            </div>
        </div>
    );
}
